// TelcoTrack — označení fyzického kusu skladu (smotek / role / metráž)

/** Max. délka označení (číslo smotku, barva, „smotek A“). */
export const WAREHOUSE_PIECE_LABEL_MAX_LENGTH = 64;

/**
 * Trim + collapse whitespace; prázdné → null.
 * Neřeže uprostřed slova — jen ořízne na max. délku.
 */
export function normalizeWarehousePieceLabel(raw: unknown): string | null {
  const text = String(raw ?? '')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text) return null;
  return text.length > WAREHOUSE_PIECE_LABEL_MAX_LENGTH
    ? text.slice(0, WAREHOUSE_PIECE_LABEL_MAX_LENGTH).trim()
    : text;
}
